var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"10","width":"100%","id":"thick-line","data-name":"thick-line"}},[_c('line',{attrs:{"x1":"0","y1":"0","x2":"100%","y2":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }